<!--计件工资单价-->
<template>
  <ls-table-layout>
    <template #search>
      <SearchForm ref="searchFormRef" @search="onSearch" />
    </template>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="exportBomSalaryUnitPriceCc" ref="download" />
      <a-button @click="onAddBill" type="primary" :disabled="btnLoading" v-hasPermi="['bom:bomSalaryUnitPriceCc:add']">
        新建
      </a-button>
      <a-button @click="importExcelHandleOpen" v-hasPermi="['bom:bomSalaryUnitPriceCc:import']">导入</a-button>
      <a-button :loading="exportLoading" @click="handleExport" v-hasPermi="['bom:bomSalaryUnitPriceCc:export']">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="baseTable"
          :columns="columns"
          :table-props="tableProps"
          :scroll="{ x: 1800, fixScreen: true }"
          :custom-selection="{ stickyFixed: true }"
        >
          <template #itemCode="{ record }">
            <global-select
              :class="{ 'error-border': record.itemCodeErrIs, 'select-width-130': true }"
              v-if="record.editIs"
              v-model="record.itemCode"
              selectType="selectAssembleSearch"
              :dropdown-match-select-width="false"
              requestApi="/mdm/mdmItemSystemItem/selectItemCodeBox"
              :selectItem="{ value: 'selectedValue', label: 'label' }"
              :setParams="{ itemType: 'CP' }"
              searchParam="itemCode"
              sourseField="res"
              :totalNum="9999999999"
              @change="(value, list) => onChangeItemCode(value, list, record)"
            />
            <template v-else>{{ record.itemCode }}</template>
          </template>
          <template #zpReferenceScale="{ record }" >
            <a-input-number
              :class="{ 'error-border': record.zpReferenceScaleErrIs }"
              v-if="record.editIs"
              v-model="record.zpReferenceScale"
              :precision="2"
              @blur="() => onChangePositiveNum(record, 'zpReferenceScale')"
            />
            <template v-else>{{ record.zpReferenceScale }}</template>
            <div class="error-text" v-if="record.zpReferenceScaleErrIs">不能小于等于0</div>
          </template>
          <template #zpWages="{ record }" >
            <a-input-number
              :class="{ 'error-border': record.zpWagesErrIs }"
              v-if="record.editIs"
              v-model="record.zpWages"
              :precision="2"
              @blur="() => onChangePositiveNum(record, 'zpWages')"
            />
            <template v-else>{{ record.zpWages }}</template>
            <div class="error-text" v-if="record.zpWagesErrIs">不能小于等于0</div>
          </template>
          <template #zpPoLaborWages="{ record }" >
            <a-input-number
              :class="{ 'error-border': record.zpPoLaborWagesErrIs }"
              v-if="record.editIs"
              v-model="record.zpPoLaborWages"
              :precision="2"
              @blur="() => onChangePositiveNum(record, 'zpPoLaborWages')"
            />
            <template v-else>{{ record.zpPoLaborWages }}</template>
            <div class="error-text" v-if="record.zpPoLaborWagesErrIs">不能小于等于0</div>
          </template>
          <template #fpWages="{ record }" >
            <a-input-number
              :class="{ 'error-border': record.fpWagesErrIs }"
              v-if="record.editIs"
              v-model="record.fpWages"
              :precision="2"
              @blur="() => onChangePositiveNum(record, 'fpWages')"
            />
            <template v-else>{{ record.fpWages }}</template>
            <div class="error-text" v-if="record.fpWagesErrIs">不能小于等于0</div>
          </template>
          <template #mbWages="{ record }" >
            <a-input-number
              :class="{ 'error-border': record.mbWagesErrIs }"
              v-if="record.editIs"
              v-model="record.mbWages"
              :precision="2"
              @blur="() => onChangePositiveNum(record, 'mbWages')"
            />
            <template v-else>{{ record.mbWages }}</template>
            <div class="error-text" v-if="record.mbWagesErrIs">不能小于等于0</div>
          </template>
          <template #otWages="{ record }" >
            <a-input-number
              :class="{ 'error-border': record.otWagesErrIs }"
              v-if="record.editIs"
              v-model="record.otWages"
              :precision="2"
              @blur="() => onChangePositiveNum(record, 'otWages')"
            />
            <template v-else>{{ record.otWages }}</template>
            <div class="error-text" v-if="record.otWagesErrIs">不能小于等于0</div>
          </template>
          <template #fbWages="{ record }" >
            <a-input-number
              :class="{ 'error-border': record.fbWagesErrIs }"
              v-if="record.editIs"
              v-model="record.fbWages"
              :precision="2"
              @blur="() => onChangePositiveNum(record, 'fbWages')"
            />
            <template v-else>{{ record.fbWages }}</template>
            <div class="error-text" v-if="record.fbWagesErrIs">不能小于等于0</div>
          </template>
          <template #smWages="{ record }" >
            <a-input-number
              :class="{ 'error-border': record.smWagesErrIs }"
              v-if="record.editIs"
              v-model="record.smWages"
              :precision="2"
              @blur="() => onChangePositiveNum(record, 'smWages')"
            />
            <template v-else>{{ record.smWages }}</template>
            <div class="error-text" v-if="record.smWagesErrIs">不能小于等于0</div>
          </template>
          <template #blWages="{ record }" >
            <a-input-number
              :class="{ 'error-border': record.blWagesErrIs }"
              v-if="record.editIs"
              v-model="record.blWages"
              :precision="2"
              @blur="() => onChangePositiveNum(record, 'blWages')"
            />
            <template v-else>{{ record.blWages }}</template>
            <div class="error-text" v-if="record.blWagesErrIs">不能小于等于0</div>
          </template>
          <template #enable="{ text, record }">
            <a-switch
              v-if="record.editIs"
              checked-children="是"
              un-checked-children="否"
              :checked="!!record.enable"
              @change="(checked) => onChangeStates(checked,record)"
            />
            <template v-else>{{ statusNameMap[text] }}</template>
          </template>
          <template #remark="{ record }">
            <a-input v-if="record.editIs" v-model="record.remark" :maxLength="200" />
            <a-tooltip v-else class="text-3-ellipsis" :title="record.remark" placement="topLeft">{{ record.remark }}</a-tooltip>
          </template>
          <template #operation="{ record }">
            <div v-hasPermi="['bom:bomSalaryUnitPriceCc:edit']">
              <a-button
                v-if="!record.editIs"
                type="link"
                class="link-btn"
                @click="() => onEdit(record, 1)"
              >编辑</a-button>
              <template v-else>
                <a-button
                  type="link"
                  class="link-btn"
                  :loading="record.loading"
                  @click="() => onSave(record)"
                >保存</a-button>
                <a-button
                  type="link"
                  class="link-btn"
                  :loading="record.loading"
                  @click="() => onEdit(record, 0)"
                >取消</a-button>
              </template>
            </div>
          </template>
        </ls-api-table>
      </div>
      <AddModal ref="addModalRef" :mainBtnLoading="btnLoading" @successCall="refreshList" />
      <ImportExcel
        ref="importExcelRef"
        :downloadParams="downloadParams"
        :uploadParams="upload"
        @refresh="refreshList"
      />
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData, transferEnumToMap } from '@/utils/util.js'
import moment from 'moment'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import SearchForm from './components/search-form.vue'
import AddModal from './components/add-modal.vue'
import ImportExcel from "@/components/ImportExcel/importExcel"
import {
  exportBomSalaryUnitPriceCc,
  listBomSalaryUnitPriceCc,
  updateBomSalaryUnitPriceCc
} from '@/api/mes/productionPrepare/pieceWageUnitPrice'
import { positiveNumValidate, STATUS_CODE } from './common'
import deepClone from 'lodash/cloneDeep'
import omit from 'lodash/omit'
export default {
  name: 'PieceWageUnitPrice',
  components: {
    DownloadModal,
    SearchForm,
    AddModal,
    ImportExcel
  },
  data() {
    this.statusNameMap = transferEnumToMap(STATUS_CODE)
    return {
      btnLoading: false,
      exportLoading: false,
      operationTypeList: [], // 工序类型
      // 用户导入参数
      upload: {
        url: process.env.VUE_APP_API_BASE_URL + '/bom/bomSalaryUnitPriceCc/import' // 上传的地址
      },
      // 导入模板下载参数
      downloadParams: {
        method: 'post',
        url: 'bom/bomSalaryUnitPriceCc/template',
        name: `计件工资单价导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
      },
      tableProps: {
        requestApi: generateLsTableResData(listBomSalaryUnitPriceCc),
        pageCurrent: false
      },
      // 表格字段
      columns: [
        {
          title: "加工组织",
          dataIndex: "organizationName",
          width: 150
        },
        {
          title: "SPU",
          dataIndex: "itemName",
          customRender: (text) => <a-tooltip class="text-3-ellipsis" title={text} placement="topLeft">{ text }</a-tooltip>,
          width: 150
        },
        {
          title: "规格",
          dataIndex: "specification",
          customRender: (text) => <a-tooltip class="text-3-ellipsis" title={text} placement="topLeft">{ text }</a-tooltip>,
          width: 150
        },
        {
          title: "成品SKU",
          dataIndex: "itemCode",
          width: 150,
          scopedSlots: { customRender: 'itemCode' }
        },
        {
          title: "规格描述",
          dataIndex: "specificationDesc",
          customRender: (text) => <a-tooltip class="text-3-ellipsis" title={text} placement="topLeft">{ text }</a-tooltip>,
          width: 150
        },
        {
          title: "真皮净用量",
          dataIndex: "zpReferenceScale",
          scopedSlots: { customRender: 'zpReferenceScale' },
          width: 100
        },
        {
          title: "真皮工价",
          dataIndex: "zpWages",
          scopedSlots: { customRender: 'zpWages' },
          width: 100
        },
        {
          title: "真皮省/超尺工价",
          dataIndex: "zpPoLaborWages",
          scopedSlots: { customRender: 'zpPoLaborWages' },
          width: 100
        },
        {
          title: "仿皮工价",
          dataIndex: "fpWages",
          scopedSlots: { customRender: 'fpWages' },
          width: 100
        },
        {
          title: "面布工价",
          dataIndex: "mbWages",
          scopedSlots: { customRender: 'mbWages' },
          width: 100
        },
        {
          title: "生态皮/硅胶皮/西皮工价",
          dataIndex: "otWages",
          scopedSlots: { customRender: 'otWages' },
          width: 100
        },
        {
          title: "辅料布工价",
          dataIndex: "fbWages",
          scopedSlots: { customRender: 'fbWages' },
          width: 100
        },
        {
          title: "丝绵工价",
          dataIndex: "smWages",
          scopedSlots: { customRender: 'smWages' },
          width: 100
        },
        {
          title: "补料工价",
          dataIndex: "blWages",
          scopedSlots: { customRender: 'blWages' },
          width: 100
        },
        {
          title: "是否生效",
          dataIndex: "enable",
          scopedSlots: { customRender: 'enable' },
          width: 100
        },
        {
          title: "备注",
          dataIndex: "remark",
          scopedSlots: { customRender: 'remark' },
          width: 100
        },
        {
          title: "创建人",
          dataIndex: "createName",
          width: 100
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          customRender: (text) => moment(text).format('YYYY-MM-DD HH:mm:ss'),
          width: 100
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right',
          align: 'center',
          width: 100
        }
      ]
    }
  },
  mounted() {
    this.refreshList();
  },
  methods: {
    exportBomSalaryUnitPriceCc,
    onChangeStates(checked, record) {
      record.enable = Number(checked);
    },
    onChangeItemCode(value, list, record) {
      const desc = list.find(item => item.selectedValue === value)?.bringOutDataThree;
      record.specificationDesc = desc;
    },
    onChangePositiveNum(record, field) {
      this.$nextTick(() => {
        positiveNumValidate(null, record[field], (err) => {
          this.$set(record, field + 'ErrIs', !!err);
        });
      })
    },
    onSave(record) {
      const params = omit(record, ['createTime', 'createName', 'specificationDesc', 'tempRow', 'updateName', 'updateTime']);
      const positiveNumList = [
        'zpPoLaborWages',
        "zpReferenceScale",
        "zpWages",
        "zpPoLabo",
        "fpWages",
        "mbWages",
        "otWages",
        "fbWages",
        "smWages",
        "blWages"
      ];
      let errIs = false;
      // if(!record.itemCode) {
      //   this.$set(record, 'itemCodeErrIs', true);
      //   errIs = true;
      // }
      for(const item of positiveNumList) {
        positiveNumValidate(null, record[item], (err) => {
          this.$set(record, item + 'ErrIs', !!err);
        });
        if(record[item + 'ErrIs']) {
          errIs = true;
        }
      }
      if(errIs) {
        return this.$message.error('填写有误');
      }
      this.$set(record, 'loading', true);
      updateBomSalaryUnitPriceCc(params).then(response => {
        if (response.code === 200) {
          this.$message.success('修改成功')
          this.refreshList(true);
        } else {
          this.$message.error(response.msg)
        }
      }).finally(() => {
        this.$set(record, 'loading', false);
      })
    },
    onEdit(record, editStatus) {
      if(editStatus) {
        record.tempRow = deepClone(record);
      }else {
        const tempRow = record.tempRow;
        for (const item in record) {
          record[item] = tempRow[item];
        }
        delete record.tempRow;
      }
      this.$set(record, 'editIs', editStatus);
    },
    // 新建
    onAddBill() {
      this.$refs.addModalRef.show()
    },
    onSearch(params) {
      if(!params.organizationCode) {
        return this.$message.error('加工组织');
      }
      this.$refs.baseTable.searchParams = params
      this.$refs.baseTable.getData(this.currentPageIs)
      this.currentPageIs = false
    },
    refreshList(currentPageIs) {
      this.currentPageIs = !!currentPageIs
      this.$refs.searchFormRef.handleFormSearch()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen() {
      this.$refs.importExcelRef.show()
    },
    /** 导出按钮操作 */
    handleExport() {
      const params = this.$refs.baseTable.searchParams;
      // this.exportLoading = true;
      // exportBomSalaryUnitPriceCc(params).finally(() => {
      //   this.exportLoading = false;
      // })
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less">
.link-btn {
  padding: 0 4px;
}
.text-3-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
/deep/.ant-input-number {
  width: 100%;
}
.select-width-130 {
  /deep/.ant-select {
    width: 120px;
  }
}
.error-border {
  border-color: #ff0000;
  /deep/.ant-select-selection {
    border-color: #ff0000;
  }
}
.error-text {
  font-size: 11px;
  color: #ff0000;
}
</style>
